/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Parq_QuestionInputs */

const en_us2_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few health questions. Answer each one yes or no.`)
};

const pt_br2_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas perguntas de saúde. Responda sim ou não em cada uma.`)
};

const es_419_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unas preguntas de salud. Responde sí o no a cada una.`)
};

const pt_pt2_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas perguntas de saúde. Responde sim ou não a cada uma.`)
};

const fr_fr2_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelques questions de santé. Réponds par oui ou non à chacune.`)
};

const de_de2_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein paar Gesundheitsfragen. Beantworte jede mit Ja oder Nein.`)
};

const it_it2_intake_parq_question = /** @type {(inputs: Intake_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualche domanda sulla salute. Rispondi sì o no a ciascuna.`)
};

/**
* | output |
* | --- |
* | "A few health questions. Answer each one yes or no." |
*
* @param {Intake_Parq_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_parq_question = /** @type {((inputs?: Intake_Parq_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Parq_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_parq_question(inputs)
	if (locale === "es-419") return es_419_intake_parq_question(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_parq_question(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_parq_question(inputs)
	if (locale === "de-DE") return de_de2_intake_parq_question(inputs)
	if (locale === "it-IT") return it_it2_intake_parq_question(inputs)
	return en_us2_intake_parq_question(inputs)
});
export { intake_parq_question as "intake.parq.question" }